import type { SVGProps } from 'react';
const DawnFlagVE = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-VE_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-VE_svg__a)">
      <path fill="#063191" d="M0 10.667h22V5.333H0z" />
      <path fill="#E2213B" d="M0 16h22v-5.333H0z" />
      <path
        fill="#fff"
        d="M11 7.467c.289 0 .524-.24.524-.534A.53.53 0 0 0 11 6.4a.53.53 0 0 0-.524.533c0 .295.234.534.524.534M8.904 8c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.523.534c0 .294.234.533.523.533m4.715-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534s.524.239.524.534M7.857 9.6c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533m6.81-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.234-.534.524-.534.289 0 .523.239.523.534"
      />
      <path fill="#FFD044" d="M0 5.333h22V0H0z" />
    </g>
  </svg>
);
export default DawnFlagVE;
